module.exports = __webpack_public_path__ + "img/ssf.c52eb1ea.jpg";